<template>
  <div class="body-container">
    <Header />
    <b-container class="content" fluid>
      <b-row class="h-100" style="flex: 1; display: flex; align-items: stretch;">
        <!--NUXT HERE -->
        <nuxt style="width: 100%; display: flex; flex-direction: column;" />
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import Header from '@/components/common/Header'
import Footer from '@/components/common/Footer'

export default {
  components: {
    Header,
    Footer
  },
  data () {
    return {}
  },
  computed: mapState(['user']),
  head () {
    return {
      script: [
        {
          hid: 'AFrame',
          src: 'https://aframe.io/releases/1.4.1/aframe.min.js'
        },
        {
          hid: 'AFrameExtras',
          src:
            'https://cdn.jsdelivr.net/gh/donmccurdy/aframe-extras@v6.1.1/dist/aframe-extras.min.js',
          defer: true
        }
      ]
    }
  }
}
</script>

<style>
@layer components {
  .tw-container {
    @apply w-full max-w-7xl mx-auto px-4;
  }
  .tw-btn {
    @apply inline-flex items-center justify-center px-4 py-2 rounded border font-medium transition;
  }
  .tw-btn-dark {
    @apply tw-btn border-gray-800 bg-gray-800 text-white hover:bg-gray-700;
  }
  .tw-btn-nav {
    @apply tw-btn bg-gray-700 text-gray-200 border-gray-600 hover:bg-gray-600 hover:text-white text-left no-underline;
  }
  .tw-btn-nav-active {
    @apply bg-gray-100 text-gray-900 border-gray-300;
  }
  .tw-btn-outline-dark {
    @apply tw-btn border-gray-500 text-gray-100 bg-transparent hover:bg-gray-700;
  }
  .tw-btn-light {
    @apply tw-btn border-gray-300 bg-white text-gray-800 hover:bg-gray-100;
  }
  .tw-card {
    @apply bg-gray-700 rounded-lg border border-gray-600 overflow-hidden;
  }
  .tw-card-body {
    @apply p-4;
  }
  .tw-form-input {
    @apply block w-full rounded border border-gray-600 bg-gray-700 text-gray-100 placeholder-gray-400 px-3 py-2 focus:border-blue-400 focus:ring-1 focus:ring-blue-400;
  }
  .tw-form-group {
    @apply mb-4;
  }
  .tw-form-label {
    @apply block text-sm font-medium text-gray-300 mb-1;
  }
}

html {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  height: 100%;
}

body {
  font-family: 'Raleway', sans-serif;
  background-color: #111827 !important; /* gray-900 — override Bootstrap's #fff */
}

.body-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: #111827;
}

.content {
  flex: 1;
  background-color: #111827;
}

.footer {
  margin-top: auto;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}
</style>
